import { Mail, MessageSquare, Phone, BellOff } from "lucide-react";

const CHANNELS = [
  { v: "email", l: "Email", icon: Mail },
  { v: "sms", l: "SMS", icon: MessageSquare },
  { v: "voice", l: "Voice Call", icon: Phone },
];

export default function ChannelPicker({ value, onChange }) {
  const silent = !value || value.length === 0;
  const toggle = (v) => (value.includes(v) ? value.filter((x) => x !== v) : [...value, v]);
  return (
    <div>
      <span className="label-mono text-[var(--text-2)]">Notify via</span>
      <div className="flex flex-wrap gap-2 mt-2">
        {CHANNELS.map(({ v, l, icon: Icon }) => (
          <button
            key={v}
            type="button"
            data-testid={`channel-${v}`}
            onClick={() => onChange(toggle(v))}
            className={`h-10 px-3 flex items-center gap-2 text-sm border transition-colors ${
              !silent && value.includes(v)
                ? "bg-[var(--accent)] text-white border-[var(--accent)]"
                : "bg-white border-[var(--line)] hover:border-[var(--accent)]"
            }`}
          >
            <Icon className="w-4 h-4" /> {l}
          </button>
        ))}
        <button
          type="button"
          data-testid="channel-none"
          onClick={() => onChange([])}
          className={`h-10 px-3 flex items-center gap-2 text-sm border transition-colors ${
            silent ? "bg-[#1A1A18] text-white border-[#1A1A18]" : "bg-white border-[var(--line)] hover:border-[#1A1A18]"
          }`}
        >
          <BellOff className="w-4 h-4" /> Do not send
        </button>
      </div>
      {silent && (
        <p className="text-xs text-[var(--text-2)] mt-2">
          In-app only — no email, SMS or call is sent (avoids messaging charges).
        </p>
      )}
    </div>
  );
}

export { CHANNELS };
